import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { AppService } from 'src/app/services/app.service';

@Component({
  selector: 'conexoes-page',
  templateUrl: './conexoes-page.component.html',
  styleUrls: ['./conexoes-page.component.scss']
})
export class ConexoesPageComponent implements OnInit {

  public loader   = false;
  public apelido  = "conexoes"; 
  public response = {
    data: "",
    status: null
  }
  public page:any     = {};
  public params:any   = {};
  public dataItem:any = {}
  public message      = "Carregando. Aguarde!";
  public itensB       = [{
    text: "Contato"
  }];
  public linkMap  = null;
  public conexoes = [];


  constructor(
    private app: AppService,
    private api: ApiService
  ){}

  /**
   * 
   * Retorna os dados da página
   * 
   */
  getData(){

    try{

      this.message = "Enviando. Aguarde!";  
      this.loader  = true;

      this.api.conteudo().page(this.apelido).subscribe(response => {

        this.loader = false;   

        if(response.status == 1){
                
          if(typeof(response.data.page) != "undefined"){
            
            this.response = {  
              data: "",
              status: 1
            }

            this.page      = typeof(response.data.page.data[0]) != "undefined" ? response.data.page.data[0] : response.data.page.data;
            this.params    = this.page.params != null ? JSON.parse(this.page.params) : {};
            this.conexoes  = response.data.page.conexoes;
            
            this.app.setMetaDados(this.page.meta_title,this.page.meta_description); 
              
          }
      
      
        }else{
          this.response = {
            data: response.data,
            status: 500 
          }
        }
        this.app.toTop(); 

      },(response) => {

        this.loader = false;
        this.app.toTop(); 
      
      });

    }catch(e){

      this.loader = false;

    }

  }
  /**
   * 
   * 
   * 
   */
  initDataItem(){

    this.dataItem = {
      nome: "",
      email: "",
      telefone: "",
      mensagem: "",
      assunto: "",
      tipo: 4
    }

  }
  /***
   * 
   * To section 
   * 
   */
  toSection(id){

    this.app.toSection(`#section-${id}`)

  }
  /**
   * 
   * Inicilaiza as Funções
   * 
   */
  ngOnInit():void{
    this.getData();
  }

}
